<template>
    <p class="text-dark-gray font-bold text-lg lg:text-xl">
        <slot></slot>
    </p>
</template>
